// src/Marketplace.js
import React, { useEffect, useState } from 'react';

function Marketplace() {
  const [products, setProducts] = useState([]);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [quantity, setQuantity] = useState(1);

  useEffect(() => {
    fetch("https://auth.fnrewards.com/api/marketplace/items", {
      method: "GET",
      credentials: "include"
    })
      .then(res => res.json())
      .then(data => setProducts(data.products))
      .catch(err => setError("Error fetching products: " + err.message));
  }, []);

  const handlePurchase = async (product) => {
    try {
      const res = await fetch("https://auth.fnrewards.com/api/marketplace/purchase", { 
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          product_id: product.id,  // using product_id to match backend
          quantity: quantity       // sending quantity
        })
      });
      const data = await res.json();
      if (!res.ok) {
        setError(data.error || "Purchase failed");
      } else {
        setMessage(data.message);
      }
    } catch (err) {
      setError("Error during purchase: " + err.message);
    }
  };

  return (
    <div style={{ padding: "20px" }}>
      <h1>Marketplace</h1>
      {error && <p style={{ color: "red" }}>{error}</p>}
      {message && <p style={{ color: "green" }}>{message}</p>}
      <div style={{ display: "flex", flexWrap: "wrap" }}>
        {products.map(product => (
          <div key={product.id} style={{ border: "1px solid #ccc", margin: "10px", padding: "10px", width: "200px" }}>
            <h3>{product.name}</h3>
            {product.image_url && <img src={product.image_url} alt={product.name} style={{ width: "100%" }} />}
            <p>{product.description}</p>
            <p>Price: {product.price} credits</p>
            <input
              type="number"
              min="1"
              value={quantity}
              onChange={e => setQuantity(Number(e.target.value))}
              style={{ width: "60px" }}
            />
            <button onClick={() => handlePurchase(product)}>
              Buy
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Marketplace;